import {combineReducers} from 'redux';
import postReducer from './postReducer';
import commonReducer from './commonReducer';
import localReducer from './localReducer';


export default combineReducers({
    posts:postReducer,
    config:commonReducer,
    localData:localReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js